import { useBoolean, VStack } from '@chakra-ui/react';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { AutoResizeTextarea } from '../../../../../components/AutoResizeTextarea';
import StyledList from '../../../../../components/StyledList';
import { useFormItems } from '../../../../../hooks/formItems';
import { UserSummary } from '../../../../../models/gen/userSummary';
import { WorkerAssignOutsourceMemberSearchResultData } from '../../../../../models/gen/workerAssignOutsourceMemberSearchResultData';
import FormAreaItem from './FormAreaItem';

/**
 * 外注メンバアサインフォームプロパティ
 */
type FormAreaProps = {
  state?: WorkerAssignOutsourceMemberSearchResultData;
  members: UserSummary[];
};
export type WorkerAssignmentFormState =
  WorkerAssignOutsourceMemberSearchResultData & {
    leader?: string;
  };

/**
 * 外注メンバアサインフォーム
 *
 * @param props -
 * @returns
 */
const FormArea: React.FunctionComponent<FormAreaProps> = (props) => {
  const form = useFormContext<WorkerAssignmentFormState>();
  const { FormRadioGroup, FormTextarea } = useFormItems(form);
  const [_, { toggle }] = useBoolean();
  const { fields } = useFieldArray({ control: form.control, name: 'members' });
  const showLeaderRadio = React.useMemo(
    () => props.state?.members?.some((member) => member.isLeader),
    [props.state?.members]
  );
  const options = React.useMemo(
    () =>
      props.members.map((member) => ({
        value: member.userCode!,
        valueToDisplay: member.name!,
      })),
    [props.members]
  );

  return (
    <VStack
      alignItems="center"
      backgroundColor="white"
      border="1px"
      padding={2}
      width="100%"
    >
      <FormRadioGroup<string> mode="edit" name="leader" options={[]}>
        <StyledList
          items={fields.map((field, idx) => (
            <FormAreaItem
              // assignWorkerId={form.getValues(`members.${idx}.assignWorkerId`)}
              field={field}
              key={field.id}
              idx={idx}
              member={props.members.find(
                (member) =>
                  member.userCode ===
                  form.getValues(`members.${idx}.userCodeMember`)
              )}
              onChange={toggle}
              options={options}
              showLeaderRadio={showLeaderRadio}
            />
          ))}
        />
      </FormRadioGroup>
      <FormTextarea
        label="メール：送信メッセージ"
        mode="edit"
        name="message"
        textareaProps={{ /* as: AutoResizeTextarea */ height: 300 }}
      />
    </VStack>
  );
};

export default FormArea;
